<template>
  <div>
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="display: flex"
          :model="searchForm"
          label-position="left"
          label-width="100px"
        >
          <el-form-item label="化学品:" style="">
            <el-input
              v-model="searchForm.param.hxpmc"
              placeholder="请输入"
              clearable
            />
          </el-form-item>

          <el-form-item label="入库时间:" style="">
            <el-col :span="10">
              <el-date-picker
                v-model="searchForm.param.beginTime"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="startTime"
                clearable
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="3">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="searchForm.param.endTime"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="endTime"
                clearable
              />
            </el-col>
          </el-form-item>
          <el-form-item label="仓库名称:">
            <el-select
              v-model="searchForm.param.cfckbm"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in cklist"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-button
            v-preventReClick
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            class="chongzhiButton"
            size="small"
            icon="el-icon-refresh-right"
            round
            @click="reset"
          >重置</el-button>
        </el-form>
      </div>
    </div>
    <div
      style="
        margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;
      "
    >
      <div class="tablemes">
        <el-table
          ref="cktable"
          :data="tableData"
          border
          :cell-style="cellStyle"
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            v-for="(item, i) in table"
            :key="i"
            :show-overflow-tooltip="true"
            align="center"
            :label="item.label"
          >
            <template slot-scope="scope">
              <span v-if="item.label !== '入库数量'">
                {{ scope.row[item.key] }}
              </span>
              <span v-else>
                {{ scope.row[item.key] }}{{ scope.row.rksldwmc }}
              </span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager,next,jumper,total,sizes"
          :page-sizes="[10, 20, 30, 40]"
          :total="total"
          :page-size="searchForm.size"
          :current-page.sync="searchForm.page"
          class="el-page"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {getQtrkTableList} from '@/assets/js/dwtz.js'
import {getListCkcx} from "@/assets/js/common"
export default {
  name: 'Tzqtrk',
  components: {
    // sideMenu,
    // Header,
  },
  data() {
    return {
      cklist: [],
      searchForm: {
        page: 1,
        size: 20,
        param: {
          hxpmc: '',
          cfckbm: '',
          beginTime: '',
          endTime: ''
        }
      },
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.param.endTime) {
            return (
              time.getTime() > new Date(this.searchForm.param.endTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.param.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() <
                new Date(this.searchForm.param.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      table: [
        {
          key: 'rkbh',
          label: '入库编号'
        },
        {
          key: 'hxpmc',
          label: '化学品名'
        },
        {
          key: 'cfckmc',
          label: '仓库名称'
        },
        {
          key: 'bgyxm',
          label: '保管员'
        },
        {
          key: 'rksl',
          label: '入库数量'
        },

        {
          key: 'rkrq',
          label: '入库日期',
          prop: 'rkrq'
        },
        {
          key: 'djsj',
          label: '登记时间'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10 // 每页的数据条数
    }
  },
  created: function() {
    this.getTableList()
    this.getCkListall()
  },
  methods: {
    /**
     * 重置查询条件
     */
    reset() {
      Object.keys(this.searchForm.param).forEach(k => this.searchForm.param[k] = '')
      this.searchForm.page = 1
      this.searchForm.size = 20
      this.getTableList(1)
    },
    // 获取仓库列表
    getCkListall() {
      getListCkcx().then((res) => {
        this.cklist = res.data.data
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.getTableList()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.searchForm.size = val
      this.getTableList()
    },
    // 生产入库
    getTableList() {
      getQtrkTableList(this.searchForm).then((res) => {
        if (res.status == 200) {
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        }
      })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 7) {
        switch (row.zt) {
          case '已出库':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '已出库,变更申请中':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '草稿':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    }
  }
}
</script>

<style lang="less" scoped>
.headerSearch {
  max-width: 1518px;
  width: 95%;
  margin: auto;
  margin-bottom: 11px;
  margin-top: 30px;
  background-color: white;
  padding: 30px 0 20px 0;
  // border: 1px solid red;
  display: flex;
  align-items: center;
  box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  .el-form-item {
    margin-bottom: 10px;
    margin-right: 30px;
    &:last-child {
      width: 90px;
      height: 39px;
      /deep/ .el-button {
        width: 90px !important;
        height: 39px;
        border-radius: 3px;
      }
    }
  }
}
/deep/ .el-table .has-gutter tr th {
  background: #eaeaea !important;
}

.sousuo {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  .sousuoButton {
    width: 90px;
    height: 39px;
    background: #4170ff;
    border-color: #4170ff;
  }
  .chongzhiButton {
    width: 90px;
    height: 39px;
  }
}
.tablemes {
  margin: auto;
  width: 90%;
  max-width: 1375px;
  // margin-top: 21px;
  // margin-bottom: 57px;
  .el-pagination__total {
    margin-left: 8px;
  }
  .el-pagination {
    padding: 10px 0;

    border: 1px solid #ebeef5;
    border-top: 0;
  }
  .deleteButton {
    background: #ff5721 !important;
    border-color: #ff5721 !important;
  }
  .el-button--warning {
    color: #fff;
    background: #feb800;
    border-radius: 3px;
    border-color: #feb800;
  }
  .el-button--primary {
    color: #fff;
    background: #4170ff;
    border-radius: 3px;
    border-color: #4170ff;
  }
  .el-pager {
    .number {
      background: #4170ff;
      border-color: #4170ff;
    }
  }
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
